var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access resolver diagnostics. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8",
                      attrs: { loading: _vm.stateLoading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        { staticClass: "grey--text text--darken-2" },
                        [
                          _vm._v(" Identity Resolver Diagnostics "),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "#006c27",
                                dark: "",
                                loading: _vm.triggerLoading,
                              },
                              on: { click: _vm.triggerRefresh },
                            },
                            [_vm._v(" Refresh Now ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "#006c27" },
                              on: { click: _vm.loadState },
                            },
                            [_vm._v(" Reload ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            { attrs: { align: "stretch" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass: "pa-4 diag-header-card",
                                      class: _vm.cacheState.ready
                                        ? "diag-header-card--success"
                                        : "diag-header-card--danger",
                                      attrs: { outlined: "", rounded: "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "diag-section-title" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                small: "",
                                                color: "#006c27",
                                              },
                                            },
                                            [_vm._v("mdi-database-search")]
                                          ),
                                          _vm._v(" Resolver Cache Snapshot "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "diag-chip-row diag-chip-row--stacked",
                                        },
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                dark: "",
                                                color: _vm.cacheState.ready
                                                  ? "#2e7d32"
                                                  : "#c62828",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    small: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.cacheState.ready
                                                          ? "mdi-check-circle"
                                                          : "mdi-alert-circle"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.cacheState.ready
                                                      ? "Ready"
                                                      : "Not Ready"
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-chip",
                                            {
                                              attrs: {
                                                small: "",
                                                dark: "",
                                                color: _vm.refreshStateColor(
                                                  _vm.activeRefreshState
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    left: "",
                                                    small: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.refreshStateIcon(
                                                          _vm.activeRefreshState
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.activeRefreshState
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.activeStage
                                        ? _c(
                                            "div",
                                            { staticClass: "diag-metric-meta" },
                                            [
                                              _vm._v(" Stage: "),
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.activeStage)),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "diag-metric-meta" },
                                            [_vm._v(" Stage: - ")]
                                          ),
                                      !_vm.cacheState.ready &&
                                      _vm.cacheState.readyReason
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "diag-metric-error",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.cacheState.readyReason
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "diag-stat-grid mt-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "diag-stat-item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cacheState
                                                        .cacheOwnerRefs || 0
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-label",
                                                },
                                                [_vm._v("Owner refs")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "diag-stat-item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cacheState
                                                        .cacheOids || 0
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-label",
                                                },
                                                [_vm._v("OIDs")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "diag-stat-item" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.cacheState
                                                        .authDecisionCount || 0
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "diag-stat-label",
                                                },
                                                [_vm._v("Auth decisions")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "6" } },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "pa-4 diag-header-card diag-header-card--neutral",
                                      attrs: { outlined: "", rounded: "" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "diag-section-title" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                small: "",
                                                color: "#5d4037",
                                              },
                                            },
                                            [_vm._v("mdi-history")]
                                          ),
                                          _vm._v(" Resolver Runs "),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "diag-run-columns",
                                          attrs: { dense: "" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "diag-run-block",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "diag-run-title",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            small: "",
                                                            color: "#1565c0",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-timer-sand"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" Current Run "),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "diag-kv-grid",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Run ID")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.currentRun
                                                                .runId || "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Trigger")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.currentRun
                                                                .trigger || "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Started")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                _vm.currentRun
                                                                  .startedAt
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.currentRun.total > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-progress-wrap",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "diag-progress-label",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Progress"
                                                                ),
                                                              ]),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .currentRun
                                                                      .processed
                                                                  ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      _vm
                                                                        .currentRun
                                                                        .total
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      _vm.formatPercent(
                                                                        _vm
                                                                          .currentRun
                                                                          .percent
                                                                      )
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-progress-linear",
                                                            {
                                                              attrs: {
                                                                value:
                                                                  _vm.currentRun
                                                                    .percent ||
                                                                  0,
                                                                color:
                                                                  "#1565c0",
                                                                "background-color":
                                                                  "#dbeaf8",
                                                                height: "8",
                                                                rounded: "",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.currentRun.error
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-metric-error",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Error: " +
                                                              _vm._s(
                                                                _vm.currentRun
                                                                  .error
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12", md: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "diag-run-block",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "diag-run-title",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "mr-1",
                                                          attrs: {
                                                            small: "",
                                                            color: "#5d4037",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-archive-clock"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" Last Run "),
                                                    ],
                                                    1
                                                  ),
                                                  _vm.lastRun.state &&
                                                  _vm.lastRun.state.toLowerCase() !==
                                                    "idle"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-chip-row",
                                                        },
                                                        [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                dark: "",
                                                                color:
                                                                  _vm.refreshStateColor(
                                                                    _vm.lastRun
                                                                      .state ||
                                                                      "idle"
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    left: "",
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.refreshStateIcon(
                                                                          _vm
                                                                            .lastRun
                                                                            .state ||
                                                                            "idle"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.lastRun
                                                                      .state ||
                                                                      "idle"
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "diag-kv-grid",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Run ID")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.lastRun
                                                                .runId || "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Trigger")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.lastRun
                                                                .trigger || "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Started")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                _vm.lastRun
                                                                  .startedAt
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Finished")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                _vm.lastRun
                                                                  .finishedAt
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-key",
                                                        },
                                                        [_vm._v("Duration")]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-kv-value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatDuration(
                                                                _vm.lastRun
                                                                  .durationMs
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.lastRun.error
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "diag-metric-error",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Error: " +
                                                              _vm._s(
                                                                _vm.lastRun
                                                                  .error
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "my-5" }),
                          _c(
                            "v-tabs",
                            {
                              attrs: {
                                color: "#006c27",
                                "background-color": "transparent",
                              },
                              model: {
                                value: _vm.activeTab,
                                callback: function ($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab",
                              },
                            },
                            [
                              _c("v-tab", [_vm._v("Resolver Cache")]),
                              _c("v-tab", [
                                _vm._v("Application Owner References"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-tabs-items",
                            {
                              staticClass: "mt-3",
                              model: {
                                value: _vm.activeTab,
                                callback: function ($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "resolver-search-row",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                "Search by oid, ownerRef, email, name, ext14",
                                              clearable: "",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.search.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.query,
                                              callback: function ($$v) {
                                                _vm.query = $$v
                                              },
                                              expression: "query",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex align-center",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              label: "Unresolved only",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.cacheUnresolvedOnly,
                                              callback: function ($$v) {
                                                _vm.cacheUnresolvedOnly = $$v
                                              },
                                              expression: "cacheUnresolvedOnly",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex align-center",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              label: "Ambiguous only",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.cacheAmbiguousOnly,
                                              callback: function ($$v) {
                                                _vm.cacheAmbiguousOnly = $$v
                                              },
                                              expression: "cacheAmbiguousOnly",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-end",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                color: "#006c27",
                                                dark: "",
                                                loading: _vm.searchLoading,
                                              },
                                              on: { click: _vm.search },
                                            },
                                            [_vm._v(" Search ")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "#006c27",
                                              },
                                              on: { click: _vm.resetSearch },
                                            },
                                            [_vm._v("Reset")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-data-table",
                                    {
                                      staticClass: "elevation-1",
                                      attrs: {
                                        headers: _vm.headers,
                                        items: _vm.searchItems,
                                        loading: _vm.searchLoading,
                                        "items-per-page": _vm.pageSize,
                                        "hide-default-footer": "",
                                      },
                                      on: { "click:row": _vm.openCacheDetail },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: `item.auth`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " E: " +
                                                        _vm._s(
                                                          _vm.boolText(
                                                            item.authDecision
                                                              .isEligibleUser
                                                          )
                                                        ) +
                                                        " | A: " +
                                                        _vm._s(
                                                          _vm.boolText(
                                                            item.authDecision
                                                              .isAdminGroupMember
                                                          )
                                                        ) +
                                                        " | B: " +
                                                        _vm._s(
                                                          _vm.boolText(
                                                            item.authDecision
                                                              .isBetaGroupMember
                                                          )
                                                        ) +
                                                        " | I: " +
                                                        _vm._s(
                                                          _vm.boolText(
                                                            item.authDecision
                                                              .isInternalVisibilityMember
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.unresolved`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.projection
                                                            .isUnresolved
                                                            ? "yes"
                                                            : "no"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.unresolvedReason`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .unresolvedReasonCode ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.ambiguous`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.projection
                                                            .isAmbiguous
                                                            ? "yes"
                                                            : "no"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.candidateCount`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .candidateCount || "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.selection`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .primarySelectionReason ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "no-data" }, [
                                        _vm.searchLoading
                                          ? _c("div", [
                                              _vm._v(
                                                "Loading cache entries ..."
                                              ),
                                            ])
                                          : _c("div", [
                                              _vm._v("No cache entries found."),
                                            ]),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end mt-3",
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            disabled:
                                              _vm.page <= 1 ||
                                              _vm.searchLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changePage(
                                                _vm.page - 1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Previous ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-caption mx-3" },
                                        [
                                          _vm._v(
                                            "Page " +
                                              _vm._s(_vm.page) +
                                              " / " +
                                              _vm._s(_vm.maxPage)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            disabled:
                                              _vm.page >= _vm.maxPage ||
                                              _vm.searchLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changePage(
                                                _vm.page + 1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Next ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "resolver-search-row",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                "Search app owners by app id, owner ref, projection fields",
                                              clearable: "",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": "",
                                            },
                                            on: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.searchAppOwners.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                            model: {
                                              value: _vm.appOwnersQuery,
                                              callback: function ($$v) {
                                                _vm.appOwnersQuery = $$v
                                              },
                                              expression: "appOwnersQuery",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex align-center",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              label: "Unresolved only",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value:
                                                _vm.appOwnersUnresolvedOnly,
                                              callback: function ($$v) {
                                                _vm.appOwnersUnresolvedOnly =
                                                  $$v
                                              },
                                              expression:
                                                "appOwnersUnresolvedOnly",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "d-flex align-center",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              label: "Ambiguous only",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.appOwnersAmbiguousOnly,
                                              callback: function ($$v) {
                                                _vm.appOwnersAmbiguousOnly = $$v
                                              },
                                              expression:
                                                "appOwnersAmbiguousOnly",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-end",
                                          attrs: { cols: "12", md: "2" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                color: "#006c27",
                                                dark: "",
                                                loading: _vm.appOwnersLoading,
                                              },
                                              on: {
                                                click: _vm.searchAppOwners,
                                              },
                                            },
                                            [_vm._v(" Search ")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "#006c27",
                                              },
                                              on: {
                                                click: _vm.resetAppOwnerSearch,
                                              },
                                            },
                                            [_vm._v("Reset")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-data-table",
                                    {
                                      staticClass: "elevation-1",
                                      attrs: {
                                        headers: _vm.appOwnerHeaders,
                                        items: _vm.appOwnerItems,
                                        loading: _vm.appOwnersLoading,
                                        "items-per-page": _vm.appOwnersPageSize,
                                        "hide-default-footer": "",
                                      },
                                      on: {
                                        "click:row": _vm.openAppOwnerDetail,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: `item.unresolved`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.projection
                                                            .isUnresolved
                                                            ? "yes"
                                                            : "no"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.reason`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .unresolvedReasonCode ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.ambiguous`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          item.projection
                                                            .isAmbiguous
                                                            ? "yes"
                                                            : "no"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.candidateCount`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .candidateCount || "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: `item.selection`,
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-caption",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.projection
                                                          .primarySelectionReason ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("template", { slot: "no-data" }, [
                                        _vm.appOwnersLoading
                                          ? _c("div", [
                                              _vm._v(
                                                "Loading app owner references ..."
                                              ),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                "No app owner entries found."
                                              ),
                                            ]),
                                      ]),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-center justify-end mt-3",
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            disabled:
                                              _vm.appOwnersPage <= 1 ||
                                              _vm.appOwnersLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeAppOwnerPage(
                                                _vm.appOwnersPage - 1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Previous ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "text-caption mx-3" },
                                        [
                                          _vm._v(
                                            " Page " +
                                              _vm._s(_vm.appOwnersPage) +
                                              " / " +
                                              _vm._s(_vm.appOwnersMaxPage) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            disabled:
                                              _vm.appOwnersPage >=
                                                _vm.appOwnersMaxPage ||
                                              _vm.appOwnersLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeAppOwnerPage(
                                                _vm.appOwnersPage + 1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" Next ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "900" },
                  model: {
                    value: _vm.detailDialog.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.detailDialog, "visible", $$v)
                    },
                    expression: "detailDialog.visible",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "text-h6 grey--text text--darken-2" },
                        [
                          _vm._v(" " + _vm._s(_vm.detailDialog.title) + " "),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.closeDetailDialog },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _vm.detailDialog.item
                            ? _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Source")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          _vm._s(_vm.detailDialog.sourceLabel)
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Primary Key")]
                                      ),
                                      _vm.detailDialog.source === "cache"
                                        ? _c("div", { staticClass: "mb-3" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.detailDialog.item.oid ||
                                                    "-"
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _c("div", { staticClass: "mb-3" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.detailDialog.item
                                                    .inputOwnerRef || "-"
                                                ) +
                                                " "
                                            ),
                                          ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Projection OwnerRef")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .ownerRef
                                                ? _vm.detailDialog.item
                                                    .projection.ownerRef
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Projection Email")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .email
                                                ? _vm.detailDialog.item
                                                    .projection.email
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Projection OID")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .oid
                                                ? _vm.detailDialog.item
                                                    .projection.oid
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Application ID")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .applicationId || "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Application Name")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .displayName || "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Environment")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .environment || "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Unresolved")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .isUnresolved
                                                ? "yes"
                                                : "no"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Ambiguous")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .isAmbiguous
                                                ? "yes"
                                                : "no"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Candidate Count")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .candidateCount
                                                ? _vm.detailDialog.item
                                                    .projection.candidateCount
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Primary Selection")]
                                      ),
                                      _c("div", { staticClass: "mb-3" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.detailDialog.item
                                                .projection &&
                                                _vm.detailDialog.item.projection
                                                  .primarySelectionReason
                                                ? _vm.detailDialog.item
                                                    .projection
                                                    .primarySelectionReason
                                                : "-"
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.detailDialog.item &&
                          _vm.detailDialog.item.projection &&
                          _vm.detailDialog.item.projection.isAmbiguous
                            ? _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-caption grey--text",
                                        },
                                        [_vm._v("Alternates")]
                                      ),
                                      _vm._l(
                                        _vm.ambiguityAlternateLines(
                                          _vm.detailDialog.item.projection
                                        ),
                                        function (line, lineIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key:
                                                "resolver-ambiguity-line-" +
                                                lineIndex,
                                              staticClass: "text-caption mb-1",
                                            },
                                            [_vm._v(" " + _vm._s(line) + " ")]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("v-divider", { staticClass: "my-3" }),
                          _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                            _vm._v("Raw Details"),
                          ]),
                          _c("pre", { staticClass: "detail-json" }, [
                            _vm._v(
                              _vm._s(_vm.detailJson(_vm.detailDialog.item))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-snackbar",
                {
                  attrs: { color: _vm.snackbar.color, timeout: "3000" },
                  model: {
                    value: _vm.snackbar.visible,
                    callback: function ($$v) {
                      _vm.$set(_vm.snackbar, "visible", $$v)
                    },
                    expression: "snackbar.visible",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.snackbar.text) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }